<template>
  <div>
    <img src="@/assets/images/pages/contract.png" class="mt-3 md:w-1/4 w-1/2 mx-auto">
    <h5 class="text-center mt-2">
      <span v-if="user_data<5">
        {{$t('To go to level 5 or vip, you can contact the support to sign the contract.')}}
      </span>
      <span v-else>
        ✅✅{{$t('You have successfully completed all the steps of authentication.')}}
      </span>
    </h5>
  </div>
</template>
<i18n locale="fa" >
{
  "To go to level 5 or vip, you can contact the support to sign the contract.":"برای رفتن به سطح 5 یا vip میتوانید با پشتیبانی جهت امضای قرارداد در تماس باشید."
  ,"You have successfully completed all the steps of authentication.":"با موفقیت تمامی مراحل احراز هویت را انجام داده اید."
}
</i18n>
<script>
    export default {
      name: "Contract",
      props:['user_data']
    }
</script>

<style scoped>

</style>
